import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from './shared-data.service';
import { RestDataService } from './rest-data.service';
import { Config } from '../config/config';
import { CmsVideos } from '../component/video-cms/video-cms';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class VideoDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

constructor( private sharedService: SharedDataService,private http: HttpClient,private config: Config,) {
}

  canDeactivate(component: CanComponentDeactivate) {
   const locked = JSON.parse(sessionStorage.getItem('isLocked'));
   const status = JSON.parse(sessionStorage.getItem('videoCmsStatus'))
   const id = JSON.parse(sessionStorage.getItem('videoCmsId'));
   const currentStatus = JSON.parse(sessionStorage.getItem('CmsStatus'));
    if(id && !locked && status != 'INPROGRESS' && !currentStatus ){
   return this.http.put(this.config.get('product').videoCmsUrl
      + "/api/cms/video/lockRelease/" +id, null).pipe(map((response: CmsVideos) => {
        if (response) {
          sessionStorage.removeItem('isLocked');
          sessionStorage.removeItem('videoCmsStatus')
          sessionStorage.removeItem('CmsStatus')
          return true;
        }
      }, (error) => {
      }));
  }
  else{
    sessionStorage.removeItem('isLocked');
    sessionStorage.removeItem('videoCmsStatus')
    sessionStorage.removeItem('CmsStatus')
    return true;
}
}


}

